import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { env } from '../config/env';
import { requestInterceptor, setAuthToken, getAuthToken } from './interceptors/request-interceptor';
import { responseInterceptor, errorInterceptor } from './interceptors/response-interceptor';
import { loggerInterceptor } from './logger';

export const httpClient: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: env.apiTimeoutMs,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use(
  requestInterceptor,
  (error) => Promise.reject(error)
);

if (env.env === 'development') {
  httpClient.interceptors.request.use(
    loggerInterceptor.request,
    (error) => Promise.reject(error)
  );
  httpClient.interceptors.response.use(
    loggerInterceptor.response,
    (error) => Promise.reject(error)
  );
}

httpClient.interceptors.response.use(
  responseInterceptor,
  errorInterceptor
);

export { setAuthToken, getAuthToken };
